<template>
  <div class="headline flex flex-row justify-between items-center">
    <h2 class="text-2xl font-semibold text-blue-600">Dashboard</h2>

    <div class="relative inline-flex shadow-sm rounded-md self-start">
      <!-- <div class="input-group">
                <input type="date" name="start" v-model="startDate" />
            </div>
            <div class="input-group ml-2">
                <input type="date" name="end" v-model="endDate" />
            </div> -->

      <div class="input-group">
        <select v-model="currentDash">
          <option
            v-if="sales"
            value="sales"
          >
            Sales Summary
          </option>
          <option
            v-if="predictive"
            value="predictive"
          >
            Predictive Sales
          </option>
          <option
            v-if="inventory"
            value="inventory"
          >
            Inventory
          </option>
        </select>
      </div>
    </div>
  </div>

  <div
    id="metric-overview"
    class="my-5"
  >
    <div class="mt-5">
      <iframe
        v-if="currentDash === 'sales'"
        class="w-full"
        :src="sales"
        onload="iFrameResize({}, this)"
        allowtransparency
      />
      <iframe
        v-if="currentDash === 'predictive'"
        class="w-full"
        :src="predictive"
        onload="iFrameResize({}, this)"
        allowtransparency
      />
      <iframe
        v-if="currentDash === 'inventory'"
        class="w-full"
        :src="inventory"
        onload="iFrameResize({}, this)"
        allowtransparency
      />
    </div>
  </div>
</template>

<script>
import DataBox from '@/Components/Cards/DataBox'
import StatusBox from '@/Components/Cards/StatusBox'
import InfoList from './InfoList'
import QuantityList from './QuantityList'
import InventoryList from './InventoryList'
import LineChart from '@/Components/Charts/LineChart'
import { iframeResize } from 'iframe-resizer'

export default {
  props: {
    /** A signed URL to access the metabase inventory dash for this customer */
    inventory: {
      type: String,
      default: null
    },
    /** A signed URL to access the metabase sales dash for this customer */
    sales: {
      type: String,
      default: null
    },
    /** A signed URL to access the metabase sales dash for this customer */
    predictive: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      currentDash: 'sales'
    }
  },

  methods: {
    iFrameResize
  }
}
</script>
